export function IsJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export function isSlashFirst(str) {
    if (!str) return false;
    return str.charAt(0) === '/';
}


// WEBPACK FOOTER //
// ./src/helpers/StringHelper.js